import React from "react";

import Section from "../../../HOC/Section";
import aboutImage from "../../../assets/img/goldnarAbout.png";

const about = () => {
  return (
    <Section id="about">
      <div className="container pt-2 pb-5">
        <div className="section-header pt-5 pb-5 text-center">
          <h3 className="section-title">
            <span>Gold Nar</span> Güzellik
          </h3>
        </div>
        <div className="section-content">
          <div className="row">
            <div className="col-md-12 col-lg-6 mb-3">
              <div className="aboutImage">
                <img
                  src={aboutImage}
                  alt="Erzincan Gold Nar Güzellik"
                  title="Erzincan Gold Nar Güzellik"
                />
              </div>
            </div>
            <div className="col-md-12 col-lg-6">
              <h5 className="about-title">Hakkında</h5>
              <div className="about-description">
                <p style={{color:"black"}}>
                  Erzincan Gold Nar Güzellik olarak kişisel bakım,
                  estetik görünüm ve konforu aynı çizgide buluşturan modern bir
                  salon deneyimi sunuyoruz. Her danışanı kendi ihtiyacına göre
                  dinleyen, hijyen ve memnuniyeti merkeze alan bir hizmet
                  yaklaşımıyla çalışıyoruz.
                </p>
                <h5 className="about-title" style={{color:"black"}}>Misyonumuz</h5>
                <div className="about-description">
                  <p style={{color:"black"}}>
                  Misyonumuz, Erzincan'da güzellik ve bakım hizmetlerini
                  güvenilir, ulaşılabilir ve profesyonel bir deneyime
                  dönüştürmektir. Cilt bakımı, lazer epilasyon, kalıcı makyaj ve
                  bölgesel bakım uygulamalarında danışanlarımızın kendini iyi,
                  bakımlı ve özel hissetmesini önemsiyoruz.
                  </p>
                </div>
                <h5 className="about-title"style={{color:"black"}}>Vizyonumuz</h5>
                <div className="about-description">
                  <p style={{color:"black"}}>
                  Vizyonumuz, Gold Nar Güzellik adını Erzincan'da kaliteli
                  hizmet, sıcak karşılama ve istikrarlı sonuç algısıyla
                  özdeşleştirmektir. Güzelliği yalnızca görünüm değil; güven,
                  rahatlık ve kendine iyi bakma alışkanlığı olarak görüyoruz.
                  </p>
                </div>

                <a
                  href="https://share.google/wj8How7D9GaZvJJha"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary mr-2"
                >
                  Konumu Gör
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default about;
